// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { Representative } from "../flow/types";

export default function(
  state: Representative = initialState.representative,
  action: any
) : Representative {
  switch (action.type) {
      case ActionTypes.SET_CONSULTANT_DATA:
        return action.payload;
    default:
      return state;
  }
}
